import React from "react";

import WeddingList from "./WeddingList";
import { TemplateSection } from "./styles";
import { Box, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PaletteIcon from "@mui/icons-material/Palette";
import { Rsvp } from "@mui/icons-material";
import ShareIcon from "@mui/icons-material/Share";
import LockIcon from "@mui/icons-material/Lock";

const WeddingTemplates = () => {
	return (
		<TemplateSection>
			<Box className={"title_wrapper"}>
				<Box className={"eyebrow"}>
					<AutoAwesomeIcon />
					Handcrafted Wedding Designs
				</Box>
				<Typography className={"title"} variant={"h1"}>
					Find Your Perfect <span className={"accent"}>Wedding Invitation</span>
				</Typography>
				<Typography className={"description"}>
					Browse beautiful invitation designs, customize every detail, manage RSVPs, and share your invitation with ease
					— all in one place.
				</Typography>
				<Box className={"trust_row"}>
					<Box className={"trust_item"}>
						<PaletteIcon />
						Fully Customizable
					</Box>
					<Box className={"trust_item"}>
						<Rsvp />
						RSVP Tracking
					</Box>
					<Box className={"trust_item"}>
						<ShareIcon />
						Instant Share Link
					</Box>
					<Box className={"trust_item"}>
						<LockIcon />
						Password Protected
					</Box>
				</Box>
			</Box>
			<WeddingList />
		</TemplateSection>
	);
};

export default WeddingTemplates;
